import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../token.service';
import {MainService} from './main.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  httpUrl;
  constructor(private http: HttpClient, private main: MainService, private token:TokenService) {
    this.httpUrl = this.main.httpUrl + '/portal';
  }
  async getImage(user_id:any) {
    const obj :any= new Object();
    obj['user_id'] = user_id;
  const resp = await this.http.post(this.httpUrl + '/getprofileimage', obj,  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) , responseType: 'blob' }).toPromise().then(res => {
      return res;
    });
    if (resp) {
      return resp;
    }
    return
  }
  async getUserProfileInfo(user_id:any){

    const res = await this.http.get<any>(this.httpUrl + '/getUserInfo'+user_id,  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;

    });
    return res;

  }
  async updateProfile(obj:any) {
    const resp = await this.http.put<any>(this.httpUrl + '/updateProfile', obj,  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
     });
    return resp;
   }
   async changePassword(obj:any) {
    const resp = await this.http.put<any>(this.httpUrl + '/changePassword', obj,  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
     });
    return resp;
   }
   async getAccProfileInfo(user_id:any){

    const res = await this.http.get<any>(this.httpUrl + '/getAccountInfo'+user_id,  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;

    });
    return res;

  }
  async getAccImage(b_acct_id:any) {
    const obj :any= new Object();
    obj['b_acct_id'] = b_acct_id;
    const resp = await this.http.post(this.httpUrl + '/getAccountImage', obj,  { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) , responseType: 'blob' }).toPromise().then(res => {
        return res;
      });
      if (resp) {
        return resp;
    }
    return
  }
}
